import React, { useEffect } from 'react';
import { Text, TouchableOpacity, View } from 'react-native';
import { ScrollView } from 'react-native-gesture-handler';
import { Searchbar } from 'react-native-paper';
import { useNavigation } from "@react-navigation/native";

import HeaderDefault from '../../components/HeaderDefault';

import styles from './styles';

const SearchUsers = (props) => {
    const navigation = useNavigation();

    return (
        <>
            <HeaderDefault title={"Buscar"} />

            <View style={styles.content}>
                <Searchbar
                    placeholder="Pesquisar"
                />

                <View style={styles.hr} />

                <ScrollView>
                    <View style={styles.contentList}>
                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate(props.route.params.page)}>
                            <Text style={styles.initials}>AB</Text>
                            <View style={styles.infoUser}>
                                <Text style={styles.nameUser}>Abelardo Bueno da Costa</Text>
                                <Text style={styles.emailUser}>abelardo@email.com</Text>
                            </View>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate(props.route.params.page)}>
                            <Text style={styles.initials}>AH</Text>
                            <View style={styles.infoUser}>
                                <Text style={styles.nameUser}>André Henrique Xavier</Text>
                                <Text style={styles.emailUser}>carlos@email.com</Text>
                            </View>
                        </TouchableOpacity>

                        <TouchableOpacity style={styles.contentItemList} onPress={() => navigation.navigate(props.route.params.page)}>
                            <Text style={styles.initials}>AL</Text>
                            <View style={styles.infoUser}>
                                <Text style={styles.nameUser}>Alexandre Lopez da Silva</Text>
                                <Text style={styles.emailUser}>lopez@email.com</Text>
                            </View>
                        </TouchableOpacity>
                    </View>
                </ScrollView>
            </View>
        </>
    );
}

export default SearchUsers;